// Types de véhicules avec icônes pour Baobab Connect
// Utilisé dans : PlanificationModal, DriverProfile, etc.

export const VEHICLE_TYPES = [
  // Camions standards
  { value: 'camion_plateau', label: 'Camion plateau', icon: '🚛', category: 'camion' },
  { value: 'camion_bache', label: 'Camion bâché', icon: '🚚', category: 'camion' },
  { value: 'camion_fourgon', label: 'Camion fourgon', icon: '📦', category: 'camion' },
  { value: 'camion_carrosserie', label: 'Camion carrosserie', icon: '🚛', category: 'camion' },
  { value: 'camion_rideaux_coulissants', label: 'Camion rideaux coulissants', icon: '🚛', category: 'camion' },
  
  // Camions bennes
  { value: 'camion_benne', label: 'Camion benne', icon: '🏗️', category: 'benne' },
  { value: 'camion_benne_laterale', label: 'Camion benne latérale', icon: '🏗️', category: 'benne' },
  { value: 'camion_benne_3_cotes', label: 'Camion benne 3 côtés', icon: '🏗️', category: 'benne' },
  { value: 'camion_benne_10_roues', label: 'Camion benne 10 roues', icon: '🏗️', category: 'benne' },
  { value: 'camion_benne_12_roues', label: 'Camion benne 12 roues', icon: '🏗️', category: 'benne' },
  
  // Camions frigorifiques / isothermes
  { value: 'camion_frigorifique', label: 'Camion frigorifique', icon: '❄️', category: 'frigo' },
  { value: 'camion_isotherme', label: 'Camion isotherme', icon: '🧊', category: 'frigo' },
  
  // Camions citernes
  { value: 'camion_citerne', label: 'Camion citerne', icon: '🛢️', category: 'citerne' },
  { value: 'camion_citerne_hydrocarbures', label: 'Camion citerne hydrocarbures', icon: '⛽', category: 'citerne' },
  { value: 'camion_citerne_chimique', label: 'Camion citerne chimique', icon: '☣️', category: 'citerne' },
  { value: 'camion_citerne_alimentaire', label: 'Camion citerne alimentaire', icon: '🥛', category: 'citerne' },
  { value: 'camion_citerne_gaz', label: 'Camion citerne à gaz', icon: '💨', category: 'citerne' },
  
  // Camions spéciaux
  { value: 'camion_grue', label: 'Camion grue', icon: '🏗️', category: 'special' },
  { value: 'camion_plateau_grue', label: 'Camion plateau grue', icon: '🏗️', category: 'special' },
  { value: 'camion_malaxeur', label: 'Camion malaxeur', icon: '🔄', category: 'special' },
  { value: 'camion_ampliroll', label: 'Camion ampliroll', icon: '🔃', category: 'special' },
  { value: 'camion_porte_engins', label: 'Camion porte-engins', icon: '🚜', category: 'special' },
  { value: 'camion_porte_char', label: 'Camion porte-char', icon: '🎖️', category: 'special' },
  { value: 'camion_aspirateur', label: 'Camion aspirateur', icon: '🌀', category: 'special' },
  { value: 'camion_atelier', label: 'Camion atelier', icon: '🔧', category: 'special' },
  { value: 'camion_poubelle', label: 'Camion poubelle', icon: '🗑️', category: 'special' },
  { value: 'camion_incendie', label: 'Camion incendie', icon: '🚒', category: 'special' },
  { value: 'camion_blinde', label: 'Camion blindé', icon: '🛡️', category: 'special' },
  { value: 'camion_surbaise', label: 'Camion surbaissé', icon: '📐', category: 'special' },
  { value: 'camion_remorque', label: 'Camion remorque', icon: '🚛', category: 'special' },
  
  // Tracteurs et semi-remorques
  { value: 'tracteur_routier', label: 'Tracteur routier', icon: '🚜', category: 'tracteur' },
  { value: 'semi_remorque', label: 'Semi-remorque', icon: '🚛', category: 'semi' },
  { value: 'semi_remorque_plateau', label: 'Semi-remorque plateau', icon: '🚛', category: 'semi' },
  { value: 'semi_remorque_bachee', label: 'Semi-remorque bâchée', icon: '🚛', category: 'semi' },
  { value: 'semi_remorque_surbaissee', label: 'Semi-remorque surbaissée', icon: '📐', category: 'semi' },
  { value: 'semi_remorque_benne', label: 'Semi-remorque benne', icon: '🏗️', category: 'semi' },
  { value: 'semi_remorque_citerne', label: 'Semi-remorque citerne', icon: '🛢️', category: 'semi' },
  { value: 'semi_remorque_frigorifique', label: 'Semi-remorque frigorifique', icon: '❄️', category: 'semi' },
  { value: 'semi_remorque_porte_conteneur', label: 'Semi-remorque porte-conteneur', icon: '📦', category: 'semi' },
  { value: 'semi_remorque_porte_voitures', label: 'Semi-remorque porte-voitures', icon: '🚗', category: 'semi' },
  
  // Véhicules légers
  { value: 'camionnette_tolee', label: 'Camionnette tôlée', icon: '🚐', category: 'leger' },
  { value: 'camionnette_frigorifique', label: 'Camionnette frigorifique', icon: '🧊', category: 'leger' },
  { value: 'pickup_simple_cabine', label: 'Pick-up simple cabine', icon: '🛻', category: 'leger' },
  { value: 'pickup_double_cabine', label: 'Pick-up double cabine', icon: '🛻', category: 'leger' },
  { value: 'triporteur_motorise', label: 'Triporteur motorisé', icon: '🛵', category: 'leger' },
  
  // Autre
  { value: 'autre', label: 'Autre', icon: '🚛', category: 'autre' },
  
  // Types du formulaire client (mockData.js) - pour compatibilité
  { value: 'carrosserie', label: 'Carrosserie', icon: '🚛', category: 'camion' },
  { value: 'fourgon', label: 'Fourgon', icon: '📦', category: 'leger' },
  { value: 'fourgon_frigo', label: 'Fourgon frigorifique', icon: '❄️', category: 'frigo' },
  { value: 'plateau', label: 'Plateau', icon: '🚚', category: 'camion' },
  { value: 'porte_char', label: 'Porte-char', icon: '🚜', category: 'special' },
  { value: 'porte_engins', label: 'Camion porte-engins', icon: '🏗️', category: 'special' },
  
  // Types legacy (seed data)
  { value: 'camion_10t', label: 'Camion 10 tonnes', icon: '🚛', category: 'camion' },
  { value: 'camion_20t', label: 'Camion 20 tonnes', icon: '🚛', category: 'camion' },
  { value: 'camion_30t', label: 'Camion 30 tonnes', icon: '🚛', category: 'camion' },
  { value: 'remorque', label: 'Remorque', icon: '🚛', category: 'semi' },
];

// Catégories pour regroupement dans le select
export const VEHICLE_CATEGORIES = [
  { value: 'camion', label: '🚛 Camions standards' },
  { value: 'benne', label: '🏗️ Camions bennes' },
  { value: 'frigo', label: '❄️ Frigorifiques / Isothermes' },
  { value: 'citerne', label: '🛢️ Citernes' },
  { value: 'special', label: '🔧 Véhicules spéciaux' },
  { value: 'tracteur', label: '🚜 Tracteurs' },
  { value: 'semi', label: '🚛 Semi-remorques' },
  { value: 'leger', label: '🚐 Véhicules légers' },
  { value: 'autre', label: '📋 Autre' },
];

// Helper pour obtenir le label d'un type
export const getVehicleTypeLabel = (value) => {
  const type = VEHICLE_TYPES.find(t => t.value === value);
  return type ? type.label : value;
};

// Helper pour obtenir l'icône d'un type
export const getVehicleTypeIcon = (value) => {
  const type = VEHICLE_TYPES.find(t => t.value === value);
  return type ? type.icon : '🚛';
};

// Helper pour grouper les types par catégorie
export const getVehicleTypesByCategory = () => {
  const grouped = {};
  VEHICLE_CATEGORIES.forEach(cat => {
    grouped[cat.value] = {
      label: cat.label,
      types: VEHICLE_TYPES.filter(t => t.category === cat.value)
    };
  });
  return grouped;
};

export default VEHICLE_TYPES;
